import { Component, OnDestroy, OnInit } from '@angular/core';
import { MenuToggleService } from '@app/shared/common';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-close-icon',
  templateUrl: './close-icon.component.html',
  styleUrls: ['./close-icon.component.scss'],
})
export class CloseIconComponent implements OnInit, OnDestroy {
  /**
   * @description
   * This is close button for sidebar.
   * The main purpose of this icon is its animation / transition
   */

  /**
   * * General
   * @isOpen This just change style of open/close button
   * @styleClass Css classes for main container
   * @subscriptions Subscriptions array
   */
  isOpen: boolean;
  styleClass: string;
  subscriptions: Subscription[] = [];

  constructor(private menuToggle: MenuToggleService) {}

  /* ====================================
  *              LIFECYCLES
  ======================================= */

  ngOnInit(): void {
    this.subscriptions.push(
      this.menuToggle.currentState.subscribe((state: any) => {
        this.toggle();
      })
    );
    this.isOpen = window.innerWidth < 500 ? false : true;
    this.toggle();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  /* ====================================
  *                HELPERS
  ======================================= */

  toggle() {
    this.isOpen = !this.isOpen;
    this.styleClass = this.isOpen ? 'is-closed' : 'is-open';
  }
}
